import React, { useEffect, useRef, useState } from "react";
import { decode } from 'blurhash';
import styles from './BlurImgContainer.module.css'

export default function BlurImgContainer({imgUrl,blurHash,height,width}){

    const [imgLoaded,setImgLoaded] = useState(false);

    useEffect(() => {
        // setImgLoaded(false);
    },[imgUrl]);

    const canvasRef = useRef(null);
    const imgRef = useRef(null);
    
    useEffect(() => {
        if (!blurHash) return;
        console.log(width,height);
        if(width > 0 && height > 0){
            const pixels = decode(blurHash, width, height);
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
    
            const imageData = ctx.createImageData(width, height);
            imageData.data.set(pixels);
            ctx.putImageData(imageData, 0, 0);
        }
    }, [ width, height]);

    return (
        <div style={{
            height: `${height}px`,
            width: `${width}px`,
            position: 'absolute',
            top: 0,
            left: 0
        }}>
            <div style={{
            height: `${height}px`,
            width: `${width}px`,
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'grid',
            alignItems: 'center',
            justifyItems: 'center',
        }}>
            {/* width={imgRef.current? imgRef.current.clientWidth : 100} height={imgRef.current? imgRef.current.clientHeight : 100} */}
                <canvas className={styles.hashImg} ref={canvasRef} width={width} height={height} style={{opacity: `${imgLoaded? 0 : 1}`}} />
            </div>
            <div style={{
            height: `${height}px`,
            width: `${width}px`,
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'grid',
            alignItems: 'center',
            justifyItems: 'center',
        }}>
                <img className={styles.fullSizeImg} ref={imgRef} src={imgUrl} style={{maxWidth: '100%', maxHeight: '100%',opacity: `${imgLoaded? 1 : 0}`}} alt="Product Image" onLoad={() => setImgLoaded(true)}/>
            </div>
        </div>
    )
}